import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppointmentStatusService {
  private statusTranslationKeys: { [key: string]: string } = {
    Awaiting: 'status.awaiting',
    CompletedPhone: 'status.completedPhone',
    CustomerNotAvailable: 'status.customerNotAvailable',
    ReadyToAssist: 'status.readyToAssist',
    CompletedVideo: 'status.completedVideo',
    SupplementaryDocumentationNeeded: 'status.supplementaryDocs',
    DocumentsProvided: 'status.docsProvided',
    Confirmed: 'status.confirmed',
    Canceled: 'status.canceled',
    SaveNpsData: 'status.saveNpsData'
  };

  getTranslationKey(status: string): string {
    return this.statusTranslationKeys[status] ?? 'status.unknown';
  }

  isVisibleToClient(status: string): boolean {
    const hiddenStatuses = [
      'VideoCallProblemConnection',
      'Rejected',
      'CallHandledByJunoOperator',
      'Televisit',
      'NewProposals',
      'CompletedWritten'
    ];
    return !hiddenStatuses.includes(status);
  }
}
